import { constants } from "utils";
import {
  CALCULATOR_ICON,
  CLIENT_ADMIN_ICON,
  CLIPBOARD_CHECK_ICON,
  CONSENSUS_ICON,
  CS_REPORTS_ICON,
  DOCUMENT_ICON,
  EDNITION_ADMIN_ICON,
  FEATURE_FLAGS_ICON,
  GROUPING_SIMULATION_ICON,
  PROMPT_CONSOLE_ICON,
  REPORTS_ICON,
  SEMANTIC_SEARCH_ICON,
  SESSION_ANALYZER_ICON,
  SESSION_REPLAY_ICON,
  USER_ADMIN_ICON,
  USER_GEAR_ICON
} from "./adminNavIcons";

const item = (label, path, { menuKey, icon, isActive } = {}) => ({ label, path, menuKey, icon, isActive });

const isUserAdminPage = (pathname) =>
  pathname === constants.USER_ADMIN_PATH || pathname.startsWith("/admin/users");
const isLcReviewPage = (pathname) => pathname.startsWith(constants.EVALUATOR_LC_REVIEW_PATH);
const isEvaluatorReviewPage = (pathname) =>
  pathname.startsWith(constants.EVALUATOR_REVIEW_PATH) && !isLcReviewPage(pathname);

export const ADMIN_NAV_GROUPS = [
  {
    id: "math-problems",
    label: constants.ADMIN_NAV_GROUP_MATH_PROBLEMS,
    items: [
      item(constants.CONSENSUS_QUESTIONS_VIEW, constants.CONSENSUS_QUESTIONS_VIEW_PATH, { icon: CONSENSUS_ICON }),
      item(constants.CONSENSUS_QUESTIONS_RENDER, constants.CONSENSUS_QUESTIONS_RENDER_PATH, { icon: CONSENSUS_ICON }),
      item(constants.IM_QUESTION_BROWSER, constants.IM_QUESTION_BROWSER_PATH, {
        menuKey: "IM_QUESTION_BROWSER",
        icon: CLIPBOARD_CHECK_ICON
      }),
      item(constants.CRAZY_CALCULATOR_QUESTIONS_VIEW, constants.CRAZY_CALCULATOR_QUESTIONS_VIEW_PATH, {
        icon: CALCULATOR_ICON
      }),
      item(constants.CRAZY_CALCULATOR_QUESTIONS_RENDER, constants.CRAZY_CALCULATOR_QUESTIONS_RENDER_PATH, {
        icon: CALCULATOR_ICON
      }),
      item(constants.WARM_UP_SETS_ADMIN, constants.WARM_UP_SETS_ADMIN_PATH, {
        menuKey: "WARM_UP_SETS_ADMIN",
        icon: CLIPBOARD_CHECK_ICON
      })
    ]
  },
  {
    id: "ai-prompts",
    label: constants.ADMIN_NAV_GROUP_AI_PROMPTS,
    items: [
      item(constants.SESSION_SUMMARY_PROMPT_CONSOLE, constants.SESSION_SUMMARY_PROMPT_CONSOLE_PATH, {
        menuKey: "SESSION_SUMMARY_PROMPT_CONSOLE",
        icon: PROMPT_CONSOLE_ICON
      }),
      item(constants.FACILITATION_AI_PROMPT_CONSOLE, constants.FACILITATION_AI_PROMPT_CONSOLE_PATH, {
        menuKey: "FACILITATION_AI_PROMPT_CONSOLE",
        icon: PROMPT_CONSOLE_ICON
      }),
      item(constants.EXPLANATION_AI_PROMPT_CONSOLE, constants.EXPLANATION_AI_PROMPT_CONSOLE_PATH, {
        menuKey: "EXPLANATION_AI_PROMPT_CONSOLE",
        icon: PROMPT_CONSOLE_ICON
      })
    ]
  },
  {
    id: "reports",
    label: constants.ADMIN_NAV_GROUP_REPORTS,
    items: [
      item(constants.CS_REPORTS, constants.CS_REPORTS_PATH, { menuKey: "CS_REPORTS", icon: CS_REPORTS_ICON }),
      item(constants.REPORTS, constants.REPORTS_PATH, { menuKey: "REPORTS", icon: REPORTS_ICON }),
      item(constants.TEACHER_REPORTS_METRICS, constants.TEACHER_REPORTS_METRICS_PATH, {
        menuKey: "TEACHER_REPORTS_METRICS",
        icon: CS_REPORTS_ICON
      })
    ]
  },
  {
    id: "session-detail",
    label: constants.ADMIN_NAV_GROUP_SESSION_DETAIL,
    items: [
      item(constants.SESSION_REPLAY, constants.SESSION_REPLAY_PATH, {
        menuKey: "SESSION_REPLAY",
        icon: SESSION_REPLAY_ICON
      }),
      item(constants.SESSION_ANALYZER, constants.SESSION_ANALYZER_PATH, {
        menuKey: "SESSION_ANALYZER",
        icon: SESSION_ANALYZER_ICON
      }),
      item(constants.ADMIN_WEEKLY_REPORTS, constants.ADMIN_WEEKLY_REPORTS_PATH, {
        menuKey: "ADMIN_WEEKLY_REPORTS",
        icon: DOCUMENT_ICON
      })
    ]
  },
  {
    id: "langfuse",
    label: constants.ADMIN_NAV_GROUP_LANGFUSE,
    items: [
      item(constants.TAGGER_PROMPT_EXPERIMENTS, constants.TAGGER_PROMPT_EXPERIMENTS_PATH, {
        menuKey: "EXPERIMENTS_COMPARISON"
      }),
      item(constants.STUDENT_FEEDBACK_EXPERIMENTS, constants.STUDENT_FEEDBACK_EXPERIMENTS_PATH, {
        menuKey: "EXPERIMENTS_COMPARISON"
      }),
      item(constants.BETTER_HINT_EXPERIMENTS, constants.BETTER_HINT_EXPERIMENTS_PATH, {
        menuKey: "EXPERIMENTS_COMPARISON"
      })
    ]
  },
  {
    id: "user-admin",
    label: constants.ADMIN_NAV_GROUP_USER_ADMIN,
    items: [
      item(constants.CLIENT_ADMIN, constants.CLIENT_ADMIN_PATH, { menuKey: "CLIENT_ADMIN", icon: CLIENT_ADMIN_ICON }),
      item(constants.USER_ADMIN, constants.USER_ADMIN_PATH, {
        menuKey: "USER_ADMIN",
        icon: USER_ADMIN_ICON,
        isActive: isUserAdminPage
      }),
      item(constants.EDNITION_ADMIN, constants.EDNITION_ADMIN_PATH, {
        menuKey: "EDNITION_ADMIN",
        icon: EDNITION_ADMIN_ICON
      }),
      item(constants.FEATURE_FLAGS_ADMIN, constants.FEATURE_FLAGS_ADMIN_PATH, {
        menuKey: "FEATURE_FLAGS_ADMIN",
        icon: FEATURE_FLAGS_ICON
      })
    ]
  },
  {
    id: "eval-skills-profile",
    label: constants.ADMIN_NAV_GROUP_EVAL_SKILLS_PROFILE,
    items: [
      item(constants.SKILLS_PROFILE_REVIEW, constants.SKILLS_PROFILE_REVIEW_PATH, {
        menuKey: "SKILLS_PROFILE_REVIEW"
      }),
      item(constants.SKILLS_PROFILE_ITEM_SELECTION, constants.SKILLS_PROFILE_ITEM_SELECTION_PATH, {
        menuKey: "SKILLS_PROFILE_ITEM_SELECTION"
      }),
      item(constants.SKILLS_PROFILE_PROMPTS, constants.SKILLS_PROFILE_PROMPTS_PATH, {
        menuKey: "SKILLS_PROFILE_PROMPTS"
      }),
      item(constants.SKILLS_PROFILE_LLM_TAGS, constants.SKILLS_PROFILE_LLM_TAGS_PATH, {
        menuKey: "SKILLS_PROFILE_LLM_TAGS"
      })
    ]
  },
  {
    id: "eval-lc-question",
    label: constants.ADMIN_NAV_GROUP_EVAL_LC_QUESTION,
    items: [
      item(constants.EVALUATOR_LC_REVIEW, constants.EVALUATOR_LC_REVIEW_PATH, {
        menuKey: "EVALUATOR_REVIEW",
        icon: CLIPBOARD_CHECK_ICON,
        isActive: isLcReviewPage
      }),
      item(constants.QUESTION_HUMAN_ANALYZE, constants.QUESTION_HUMAN_ANALYZE_PATH, {
        menuKey: "QUESTION_HUMAN_ANALYZE",
        icon: USER_GEAR_ICON
      }),
      item(constants.EVALUATOR_REVIEW, constants.EVALUATOR_REVIEW_PATH, {
        menuKey: "EVALUATOR_REVIEW",
        icon: CLIPBOARD_CHECK_ICON,
        isActive: isEvaluatorReviewPage
      })
    ]
  },
  {
    id: "other",
    label: constants.ADMIN_NAV_GROUP_OTHER,
    items: [
      item(constants.SEMANTIC_SEARCH, constants.SEMANTIC_SEARCH_PATH, {
        menuKey: "SEMANTIC_SEARCH",
        icon: SEMANTIC_SEARCH_ICON
      }),
      item(constants.GROUPING_SIMULATION, constants.GROUPING_SIMULATION_PATH, {
        menuKey: "GROUPING_SIMULATION",
        icon: GROUPING_SIMULATION_ICON
      })
    ]
  }
];
